import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

import {ref} from 'vue';
import { MessageDialog } from '../../../../framework/frontend/MessageDialog';
import { block_translation } from '../../../lang/BlockTranslation';
import { SessionUser } from '../../../utils/SessionUser';
import { WordToImageCanvasARService } from "../../../biz/remote/WordToImageCanvasARService";
import LoadingView from "../../../components/common/LoadingView.vue";
import NewBadge from '../../../components/common/NewBadge.vue';

interface Prop{
  assetPath:string;
  reloadCallBack : () => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ToCanvasGlbButton',
  props: {
    assetPath: null,
    reloadCallBack: null
  },
  setup(__props: any) {

const props = __props as {
  assetPath:string;
  reloadCallBack : () => void;
};



const loading = ref(false);

const t = block_translation;
const buttonName = t.to("3Dキャンバスに描く","to_canvas_glb")

const addImageElement = async (): Promise<void> => {
  loading.value =true;
  try{
    console.log("" , props.assetPath)
    const fileName = props.assetPath.split("/").reverse()[0];
    const biz = new WordToImageCanvasARService();
    const response = await biz.imageToCanvasModel(SessionUser.instance.userId,  fileName)

    MessageDialog.info( response.data)
    MessageDialog.info(`3Dキャンバスに描いたファイルを追加しました`);
    props.reloadCallBack();
  }catch(e){
    MessageDialog.error(`3Dキャンバスへの変換中にエラーが発生しました ${e}`)
  }finally{
    loading.value =false
  }
  
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn btn-outline-dark",
    onClick: addImageElement
  }, [
    (loading.value)
      ? (_openBlock(), _createBlock(LoadingView, { key: 0 }))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_unref(buttonName)) + " ", 1),
    _createVNode(NewBadge)
  ]))
}
}

})